import { render } from "./ComboBoxSave.vue?vue&type=template&id=6d11d4aa"
import script from "./ComboBoxSave.vue?vue&type=script&lang=js"
export * from "./ComboBoxSave.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__